import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainText: {
    color: theme.palette.grey[700],
    fontWeight: 500,
    whiteSpace: 'pre-line'
  },
  boldText: {
    color: theme.palette.grey[800],
    fontWeight: 600,
    fontSize: 12
  },
  greenText: {
    color: theme.palette.secondary.main,
    fontWeight: 600
  },
  rightText: {
    textAlign: 'right'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '7fr 4fr',
    marginBottom: 8
  }
}))
